export { default } from './FmvDealBadge'
